





















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import HikEventView from '@/components/hikEvent/view.vue'
import PdfViewer from '@/components/pdfViewer.vue'
import PointInMap from '@/components/pointInMap.vue'

import UnitInfoView from '@/components/heritageUnit/view/index.vue'
import OtherUnitView from '@/components/heritageUnit/view/otherUnit/index.vue'
import UserView from '@/components/systemManage/user/view.vue'
import VideoDeviceView from '@/components/videoDevice/view/index.vue'
import VideoPointView from '@/components/videoDevice/view/point/view.vue'
import PopH5Play from '@/components/hikVideo/popH5Play.vue'
@Component({
  components: {
    HikEventView, PopH5Play,
    PdfViewer, PointInMap,
    UserView, UnitInfoView, OtherUnitView,
    VideoDeviceView, VideoPointView
  }
})
export default class App extends Vue {

  public created() {
  }
  public mounted() {
  }
  public destroyed() {
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    var path = route.path
    let isDashboard = (path == '/dashboard' || path == '/' || path == '')
    this.setBodyClass(isDashboard)
  }

  setBodyClass(add: boolean) {
    var bodyClass = document.body.className
    var newClass = 'dark'
    if (add) {
      if (bodyClass.indexOf(newClass) == -1) {
        bodyClass = bodyClass + ' ' + newClass
      }
    }
    else {
      if (bodyClass.indexOf(newClass) > -1) {
        bodyClass = bodyClass.replace(newClass, '')
      }
    }
    document.body.className = bodyClass
  }
}
